import React from 'react';
import { Activity, Building2, Flame, Layers, TrendingUp } from 'lucide-react';
import { formatTimes } from '../../utils/topSubscribed';

const Card = ({ label, value, chip, note, Icon, highlight = false }) => (
  <li
    className={`min-w-0 rounded-2xl border p-4 shadow-sm ${
      highlight ? 'bg-gradient-to-br from-[#006666] to-[#008080] border-[#006666] text-white' : 'bg-white border-slate-200/90'
    }`}
  >
    <div className="flex items-start justify-between gap-2">
      <p className={`text-[10px] font-bold uppercase tracking-wider ${highlight ? 'text-teal-100' : 'text-slate-500'}`}>{label}</p>
      <span
        className={`w-7 h-7 rounded-lg flex items-center justify-center flex-shrink-0 ${
          highlight ? 'bg-white/15 text-white' : 'bg-teal-50 text-[#008080] border border-teal-100'
        }`}
      >
        <Icon className="w-3.5 h-3.5" aria-hidden="true" />
      </span>
    </div>
    <p className="mt-1.5 flex flex-wrap items-baseline gap-x-2">
      <span className={`text-2xl sm:text-[26px] font-extrabold tracking-tight tabular-nums ${highlight ? 'text-white' : 'text-slate-900'}`}>
        {value}
      </span>
      {chip && <span className={`text-[11px] font-bold ${highlight ? 'text-teal-100' : 'text-[#008080]'}`}>{chip}</span>}
    </p>
    <p className={`mt-1 text-[11px] truncate ${highlight ? 'text-teal-50/90' : 'text-slate-400'}`} title={note}>
      {note}
    </p>
  </li>
);

// stats: utils/topSubscribed.js computeTopStats
export const TopStatCards = ({ stats, loading }) => {
  if (loading) {
    return (
      <ul className="grid grid-cols-2 lg:grid-cols-5 gap-3 sm:gap-4">
        {Array.from({ length: 5 }).map((_, idx) => (
          <li key={idx} className="h-[104px] rounded-2xl border border-slate-200/90 bg-white shadow-sm animate-pulse" />
        ))}
      </ul>
    );
  }

  return (
    <ul className="grid grid-cols-2 lg:grid-cols-5 gap-3 sm:gap-4">
      <Card
        label="Most Subscribed"
        value={stats.top ? formatTimes(stats.top.times) : '—'}
        note={stats.top ? stats.top.name : 'No bidding data yet'}
        Icon={Flame}
        highlight
      />
      <Card label="Above 10x" value={stats.above10} note="Heavily oversubscribed issues" Icon={TrendingUp} />
      <Card
        label="Fully Subscribed"
        value={stats.fullySubscribed}
        chip={stats.total ? `of ${stats.total}` : null}
        note="Demand at or above 1.00x"
        Icon={Layers}
      />
      <Card label="Bidding Open" value={stats.live} note="Still taking bids today" Icon={Activity} />
      <Card label="SME Issues" value={stats.sme} chip={`${stats.mainboard} mainboard`} note="Split of the ranking by board" Icon={Building2} />
    </ul>
  );
};

export default TopStatCards;
